import axios from '@/libs/api.request'
import {getToken} from '@/libs/util'
import config from '@/config'

// 数据库管理基础URL
const baseDBUrl = config.baseDBUrl
const dbBaseUrl = baseDBUrl + '/database/api/v1/'

const baseHeaders = {
  'Authorization': 'OPS ' + getToken()
}

export const getInstanceList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'sqlserver/instance/',
    headers: baseHeaders,
    params: params,
    method: 'get',
    paramsSerializer: function (params) {
      return require('qs').stringify(params, { indices: false })
    }
  })
}

export const getProcessList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'sqlserver/processlist/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const getInstanceUserList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'sqlserver/userlist/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const getInstanceAllUserList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/all_userlist/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const deleteInstance = (id) => {
  return axios.request({
    url: dbBaseUrl + 'sqlserver/instance/' + id + '/',
    method: 'delete'
  })
}

export const pushInstance = (data, id) => {
  let url = dbBaseUrl + 'sqlserver/instance/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const resetUserPassword = (data) => {
  return axios.request({
    url: dbBaseUrl + 'sqlserver/password/reset/',
    data: data,
    method: 'POST'
  })
}

export const deleteInstanceUser = (data) => {
  return axios.request({
    url: dbBaseUrl + 'sqlserver/user/remove/',
    data: data,
    method: 'POST'
  })
}

export const getPrivList = (data) => {
  return axios.request({
    url: dbBaseUrl + 'sqlserver/user/privilege/',
    data: data,
    method: 'POST'
  })
}

export const getDBRoleList = (data) => {
  return axios.request({
    url: dbBaseUrl + 'sqlserver/user/role/db/',
    data: data,
    method: 'POST'
  })
}

export const getServerRoleList = (data) => {
  return axios.request({
    url: dbBaseUrl + 'sqlserver/user/role/server/',
    data: data,
    method: 'POST'
  })
}

export const revokePrivilege = (data) => {
  return axios.request({
    url: dbBaseUrl + 'sqlserver/user/privilege/revoke/',
    data: data,
    method: 'POST'
  })
}

export const showDatabaseList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'sqlserver/database/show/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const getDatabaseList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'sqlserver/database/list/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const addDatabase = (data) => {
  return axios.request({
    url: dbBaseUrl + 'sqlserver/database/add/',
    headers: baseHeaders,
    data: data,
    method: 'POST'
  })
}

export const removeDatabase = (data) => {
  return axios.request({
    url: dbBaseUrl + 'sqlserver/database/remove/',
    headers: baseHeaders,
    data: data,
    method: 'POST'
  })
}

export const editLoginUser = (data) => {
  return axios.request({
    url: dbBaseUrl + 'sqlserver/user/alter/',
    data: data,
    method: 'POST'
  })
}

export const getParamList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'sqlserver/current/parameter/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const setParam = (data) => {
  return axios.request({
    url: dbBaseUrl + 'sqlserver/current/parameter/set/',
    data: data,
    method: 'POST'
  })
}

export const getInstanceLogList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'sqlserver/server/log/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const getOpsLogList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'sqlserver/instancelog/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const getInstanceStats = (params) => {
  return axios.request({
    url: dbBaseUrl + 'sqlserver/stats/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const explainSQL = (data) => {
  return axios.request({
    url: dbBaseUrl + 'sqlserver/sql/explain/',
    headers: baseHeaders,
    data: data,
    method: 'POST'
  })
}

export const executeSQL = (data) => {
  return axios.request({
    url: dbBaseUrl + 'sqlserver/sql/execute/',
    headers: baseHeaders,
    data: data,
    method: 'POST'
  })
}

export const getExecuteLog = (params) => {
  return axios.request({
    url: dbBaseUrl + 'sqlserver/execute/log/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const getServerRole = (data) => {
  return axios.request({
    url: dbBaseUrl + 'sqlserver/role/server/',
    data: data,
    method: 'POST'
  })
}

export const getDBRole = (data) => {
  return axios.request({
    url: dbBaseUrl + 'sqlserver/role/db/',
    data: data,
    method: 'POST'
  })
}

export const createUser = (data) => {
  return axios.request({
    url: dbBaseUrl + 'sqlserver/user/create/',
    headers: baseHeaders,
    data: data,
    method: 'POST'
  })
}

export const getDBSchema = (data) => {
  return axios.request({
    url: dbBaseUrl + 'sqlserver/database/schema/',
    headers: baseHeaders,
    data: data,
    method: 'POST'
  })
}

export const addUserPrivs = (data) => {
  return axios.request({
    url: dbBaseUrl + 'sqlserver/user/privilege/add/',
    data: data,
    method: 'POST'
  })
}

export const showTableList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'sqlserver/table/show/',
    params: params,
    method: 'get'
  })
}
